import { c as _c } from "react/compiler-runtime";
import { useMemo } from 'react';
import { useQuery } from '@apollo/client';
import { GET_PRODUCTS_ORDER_ETA } from '@/graphql/queries';
import getFormattedDate from './getFormattedDate';
const useProductOrderETA = productId => {
  const $ = _c(10);
  let t0;
  if ($[0] !== productId) {
    t0 = {
      productIds: [productId]
    };
    $[0] = productId;
    $[1] = t0;
  } else {
    t0 = $[1];
  }
  const t1 = !productId;
  let t2;
  if ($[2] !== t0 || $[3] !== t1) {
    t2 = {
      variables: t0,
      skip: t1,
      ssr: true
    };
    $[2] = t0;
    $[3] = t1;
    $[4] = t2;
  } else {
    t2 = $[4];
  }
  const {
    loading,
    data
  } = useQuery(GET_PRODUCTS_ORDER_ETA, t2);
  let t3;
  bb0: {
    const dateString = data?.getOrderETAForProductIds?.[productId];
    if (!productId || loading || !dateString) {
      t3 = "";
      break bb0;
    }
    let t4;
    if ($[5] !== dateString) {
      t4 = getFormattedDate(dateString);
      $[5] = dateString;
      $[6] = t4;
    } else {
      t4 = $[6];
    }
    const formattedDate = t4;
    t3 = formattedDate;
  }
  const eta = t3;
  let t4;
  if ($[7] !== eta || $[8] !== loading) {
    t4 = {
      eta,
      loading
    };
    $[7] = eta;
    $[8] = loading;
    $[9] = t4;
  } else {
    t4 = $[9];
  }
  return t4;
};
export default useProductOrderETA;